import icText from '../../assets/images/svg/ic-text.svg';
import icImage from '../../assets/images/svg/ic-image.svg';
import icCardItem from '../../assets/images/svg/ic-card-item.svg';
import icTextHover from '../../assets/images/svg/ic-text-hover.svg';
import icImageHover from '../../assets/images/svg/ic-image-hover.svg';
import icCardItemHover from '../../assets/images/svg/ic-card-item-hover.svg';
import icLinePoint from '../../assets/images/svg/ic-line-points.svg';
import icLinePointHover from '../../assets/images/svg/ic-line-points-hover.svg';
import icCoupon from '../../assets/images/svg/ic-coupon.svg';
import icCouponHover from '../../assets/images/svg/ic-coupon-hover.svg';

const GROWTHTOOL_TYPE = {
  text: icText,
  image: icImage,
  card: icCardItem,
  textHover: icTextHover,
  imageHover: icImageHover,
  cardHover: icCardItemHover,
  linePoint: icLinePoint,
  linePointHover: icLinePointHover,
  coupon: icCoupon,
  couponHover: icCouponHover,
};

export default GROWTHTOOL_TYPE;
